module.exports = __webpack_public_path__ + "static/media/bt.ef7c8f81.svg";